import React from 'react';
import { NavLink } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { 
  FaSave, 
  FaArrowLeft, 
  FaRobot, 
  FaKey, 
  FaLink 
} from 'react-icons/fa';
import withRouter from '../../../util/WithRouter';

class AddAiIntegration extends React.Component {
  state = {
    name: '',
    providerType: '',
    apiKey: '',
    secretKey: '',
    baseUrl: '',
    webhookUrl: '',
    status: 1,
    errors: {}
  };

  // AI Provider options
  providerOptions = [
    { value: 'Sarvan AI', label: 'Sarvan AI' },
    { value: 'Floatbot AI', label: 'Floatbot AI' },
    { value: 'Vapi AI', label: 'Vapi AI' },
    { value: 'Corover AI', label: 'Corover AI' },
    { value: 'Verloop AI', label: 'Verloop AI' },
    { value: 'Nurix AI', label: 'Nurix AI' },
    { value: 'Awaz AI', label: 'Awaz AI' },
    { value: 'Haptik AI', label: 'Haptik AI' },
    { value: 'Squadstack AI', label: 'Squadstack AI' },
    { value: 'Bolna AI', label: 'Bolna AI' },
    { value: 'Pulse AI', label: 'Pulse AI' },
    { value: 'Gupshup AI', label: 'Gupshup AI' },
    { value: 'Elevenlabs AI', label: 'Elevenlabs AI' }
  ];

  handleChange = (field, value) => {
    this.setState({ 
      [field]: value,
      errors: { ...this.state.errors, [field]: '' }
    });
  };

  validateForm = () => {
    const { name, providerType, apiKey } = this.state;
    const errors = {};

    if (!providerType) errors.providerType = 'Please select AI Provider';
    if (!name.trim()) errors.name = 'Integration name is required';
    if (!apiKey.trim()) errors.apiKey = 'API Key is required';

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSave = () => {
    if (this.validateForm()) {
      alert('AI Integration saved successfully!');
    }
  };

  render() {
    const { name, providerType, apiKey, secretKey, baseUrl, webhookUrl, status, errors } = this.state;
    const isEdit = this.props.match.params.id !== '0';

    return (
      <div className="sectionform pt-4">
        <div className="container-fluid form-cont">
          
          {/* Header */}
          <div className="row mb-4">
            <div className="col-md-8">
              <h3 className="mb-2">
                {isEdit ? 'Edit AI Integration' : 'Add AI Integration'}
              </h3>
              <p className="text-muted">Configure your AI service integration</p>
            </div>
            <div className="col-md-4 text-right">
              <NavLink 
                to="/setting/third-party/ai-integration" 
                className="btn btn-outline-secondary btn-sm"
              >
                <FaArrowLeft /> Back to List
              </NavLink>
            </div>
          </div>

          {/* Main Form */}
          <div className="row">
            <div className="col-md-12">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  
                  <Form>
                    {/* Row 1: Provider and Name */}
                    <div className="row">
                      {/* AI Provider */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            AI Service Provider <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            value={this.providerOptions.find(opt => opt.value === providerType)}
                            onChange={(selected) => this.handleChange('providerType', selected?.value || '')}
                            options={this.providerOptions}
                            placeholder="Select AI Provider"
                            isSearchable
                            className={`${errors.providerType ? 'is-invalid' : ''}`}
                          />
                          {errors.providerType && (
                            <div className="invalid-feedback d-block">{errors.providerType}</div>
                          )}
                        </Form.Group>
                      </div>

                      {/* Integration Name */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            Integration Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="e.g., Customer Support Bot"
                            value={name}
                            onChange={(e) => this.handleChange('name', e.target.value)}
                            isInvalid={!!errors.name}
                          />
                          {errors.name && (
                            <Form.Control.Feedback type="invalid">
                              {errors.name}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </div>
                    </div>

                    {/* Row 2: API Key and Secret Key */}
                    <div className="row">
                      {/* API Key */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            API Key <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Enter your API key"
                            value={apiKey}
                            onChange={(e) => this.handleChange('apiKey', e.target.value)}
                            isInvalid={!!errors.apiKey}
                          />
                          {errors.apiKey && (
                            <Form.Control.Feedback type="invalid">
                              {errors.apiKey}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </div>

                      {/* Secret Key */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            Secret Key
                          </Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Enter secret key if required"
                            value={secretKey}
                            onChange={(e) => this.handleChange('secretKey', e.target.value)}
                          />
                        </Form.Group>
                      </div>
                    </div>

                    {/* Row 3: Base URL and Webhook URL */}
                    <div className="row">
                      {/* Base URL */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            Base API URL
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="https://api.ai-service.com/v1"
                            value={baseUrl}
                            onChange={(e) => this.handleChange('baseUrl', e.target.value)}
                          />
                        </Form.Group>
                      </div>

                      {/* Webhook URL */}
                      <div className="col-md-6 mb-3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold">
                            Webhook URL
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="https://your-domain.com/webhook"
                            value={webhookUrl}
                            onChange={(e) => this.handleChange('webhookUrl', e.target.value)}
                          />
                        </Form.Group>
                      </div>
                    </div>

       
                    {/* Save Button */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right mt-3 pt-3 border-top">
                          <Button 
                            variant="success" 
                            onClick={this.handleSave}
                            className="px-4"
                          >
                            <FaSave className="mr-2" />
                            {isEdit ? 'Update Integration' : 'Save Integration'}
                          </Button>
                        </div>
                      </div>
                    </div>

                  </Form>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default withRouter(AddAiIntegration);